import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';

function Navbar() {
    const [activeSection, setActiveSection] = useState('home');
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleActiveSectionChange = () => {
            if (window.activeSection) {
                setActiveSection(window.activeSection);
            }
        };

        window.addEventListener('activeSectionChange', handleActiveSectionChange);
        handleActiveSectionChange(); // Initial check

        return () => window.removeEventListener('activeSectionChange', handleActiveSectionChange);
    }, []);

    const handleLinkClick = () => {
        setMobileMenuOpen(false);
    };

    const getLinkStyle = (section) => ({
        textDecoration: 'none',
        color: activeSection === section ? '#3182CE' : '#4A5568',
        fontWeight: activeSection === section ? '700' : '500',
        fontSize: activeSection === section ? '1.05rem' : '1rem',
        transition: 'all 0.3s ease',
        borderBottom: activeSection === section ? '2px solid #3182CE' : 'none',
        paddingBottom: '0.25rem'
    });

    return (
        <>
            <style>{`
                @media (max-width: 768px) {
                    .desktop-nav { display: none !important; }
                    .mobile-menu-button { display: block !important; }
                }
                @media (min-width: 769px) {
                    .desktop-nav { display: flex !important; }
                    .mobile-menu-button { display: none !important; }
                    .mobile-menu { display: none !important; }
                }
            `}</style>

            <nav style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem clamp(1rem, 5vw, 2rem)',
                position: 'sticky',
                top: 0,
                background: '#FFFFFF',
                borderBottom: '1px solid #E2E8F0',
                zIndex: 1000
            }}>
                <a href="#home" onClick={handleLinkClick} style={{
                    fontWeight: 'bold',
                    fontSize: 'clamp(1rem, 3vw, 1.2rem)',
                    textDecoration: 'none',
                    color: '#1A365D'
                }}>
                    Charles Cetta
                </a>

                {/* Desktop Navigation */}
                <div className="desktop-nav" style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
                    <a href="#projects" style={getLinkStyle('projects')}>Projects</a>
                    <a href="#skills" style={getLinkStyle('skills')}>Skills</a>
                    <a href="#contact" style={getLinkStyle('contact')}>Contact</a>

                    <div style={{ display: 'flex', gap: '1rem', marginLeft: '1rem' }}>
                        <a
                            href="https://www.linkedin.com/in/charles-cetta-44b620228/"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#4A5568', fontSize: '1.2rem', transition: 'color 0.2s' }}
                            onMouseEnter={(e) => e.target.style.color = '#2B6CB0'}
                            onMouseLeave={(e) => e.target.style.color = '#4A5568'}
                        >
                            <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                        <a
                            href="https://github.com/charles-cetta"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#4A5568', fontSize: '1.2rem', transition: 'color 0.2s' }}
                            onMouseEnter={(e) => e.target.style.color = '#2B6CB0'}
                            onMouseLeave={(e) => e.target.style.color = '#4A5568'}
                        >
                            <FontAwesomeIcon icon={faGithub} />
                        </a>
                        <a
                            href="mailto:cetta.charles.contact@gmail.com"
                            style={{ color: '#4A5568', fontSize: '1.2rem', transition: 'color 0.2s' }}
                            onMouseEnter={(e) => e.target.style.color = '#2B6CB0'}
                            onMouseLeave={(e) => e.target.style.color = '#4A5568'}
                        >
                            <FontAwesomeIcon icon={faEnvelope} />
                        </a>
                    </div>
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="mobile-menu-button"
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    style={{
                        display: 'none',
                        background: 'none',
                        border: 'none',
                        color: '#1A365D',
                        fontSize: '1.5rem',
                        cursor: 'pointer',
                        padding: '0.5rem'
                    }}
                    aria-label="Toggle menu"
                >
                    <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
                </button>
            </nav>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="mobile-menu" style={{
                    position: 'fixed',
                    top: '67px',
                    left: 0,
                    right: 0,
                    background: '#FFFFFF',
                    borderBottom: '2px solid #E2E8F0',
                    padding: '1.5rem',
                    zIndex: 999,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                        <a
                            href="#projects"
                            onClick={handleLinkClick}
                            style={{
                                ...getLinkStyle('projects'),
                                fontSize: '1.1rem',
                                padding: '0.5rem 0'
                            }}
                        >
                            Projects
                        </a>
                        <a
                            href="#skills"
                            onClick={handleLinkClick}
                            style={{
                                ...getLinkStyle('skills'),
                                fontSize: '1.1rem',
                                padding: '0.5rem 0'
                            }}
                        >
                            Skills
                        </a>
                        <a
                            href="#contact"
                            onClick={handleLinkClick}
                            style={{
                                ...getLinkStyle('contact'),
                                fontSize: '1.1rem',
                                padding: '0.5rem 0'
                            }}
                        >
                            Contact
                        </a>

                        <div style={{
                            display: 'flex',
                            gap: '1.5rem',
                            marginTop: '1rem',
                            paddingTop: '1.5rem',
                            borderTop: '1px solid #E2E8F0'
                        }}>
                            <a
                                href="https://www.linkedin.com/in/charles-cetta-44b620228/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#4A5568', fontSize: '1.5rem' }}
                            >
                                <FontAwesomeIcon icon={faLinkedin} />
                            </a>
                            <a
                                href="https://github.com/charles-cetta"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#4A5568', fontSize: '1.5rem' }}
                            >
                                <FontAwesomeIcon icon={faGithub} />
                            </a>
                            <a
                                href="mailto:cetta.charles.contact@gmail.com"
                                style={{ color: '#4A5568', fontSize: '1.5rem' }}
                            >
                                <FontAwesomeIcon icon={faEnvelope} />
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Navbar;